// extracted by mini-css-extract-plugin
module.exports = {"form":"CreateClassroomModal_form__kPoC_","field":"CreateClassroomModal_field__Rs_C6","inline":"CreateClassroomModal_inline__LKgca"};